import { createFileRoute, Outlet, useParams } from '@tanstack/react-router';
import { TopBar } from '@/components/layout/topbar';
import { Sidebar } from '@/components/layout/sidebar';
import { useMe } from '@/hooks/use-me';

export const Route = createFileRoute('/_authenticated')({
  component: Layout,
});

function Layout() {
  const { data: me, isLoading, error } = useMe();
  const params = useParams({ strict: false }) as { siteId?: string };

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center text-text-muted text-sm">
        Loading…
      </div>
    );
  }

  if (error || !me) {
    return (
      <div className="flex h-screen items-center justify-center text-text-muted text-sm">
        <div>
          <p className="mb-2 text-base font-semibold text-text">Unable to authenticate.</p>
          <p>Please refresh and sign in with your @alivevietnam.com account.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-[240px_1fr] grid-rows-[56px_1fr] min-h-screen">
      <TopBar />
      <Sidebar siteId={params.siteId} />
      <main className="overflow-y-auto bg-bg-base">
        <Outlet />
      </main>
    </div>
  );
}
